import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {Create} from '@mui/icons-material'
import Graphic from 'components/Graphic'
import Loader from './Loader'
import {chartType} from 'utils/enums/graphics'

const Name = styled.span`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-height: 20px;
    margin-bottom: 20px;
    line-height: 20px;
    font-weight: 700;
    font-size: 16px;
`

const Container = styled.div`
    position: relative;
    height: ${props => props.hasTitle ? 'calc(100% - 40px)' : '100%'};
`

const Empty = styled.div`
    width: 100%;
    font-weight: 600;
    font-size: 36px;
    line-height: 1;
    white-space: nowrap;
`

const Icon = styled(Create)`
	color: rgb(107, 107, 107);
	font-size: 16px;
	padding: 5px;
	background: rgba(255, 255, 255, 0.5);
	border-radius: 10px;
	margin-left: auto;
	margin-top: -20px;
	margin-right: -20px;
`

class GraphicCard extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        this.props.getRollup(this.props.id)
        this.setState({loading: true})
    }

    componentDidUpdate(prevProps) {
        if (this.props.rollupValue && this.state.loading) {
            this.setState({loading: false })
        }

        if (this.props.updating === this.props.id) {
            this.props.getRollup(this.props.id)
            this.setState({loading: true})
        }
    }

    handleClick = (e) => {
        e.stopPropagation()
        this.props.handleClick(this.props.type, this.props.id)
    }

    // handleCopy = (e) => {
    //     e.stopPropagation()
    //     this.props.handleCopy(this.props.id)
    // }

    render() {
        return (
            <React.Fragment>
                {!this.props.mobile && this.props.isDesigner && this.props.editable &&
                    <Icon
                        onClick={this.handleClick}
                    />
                }
                {!this.props.hideLabel && this.props.name &&
                    <Name>{this.props.name}</Name>
                }
                <React.Fragment>
                    {this.state.loading ?
                        <Loader />
                        :
                        <React.Fragment>
                            {this.props.rollupValue && this.props.rollupValue.data.length ?
                                <Container hasTitle={!this.props.hideLabel && this.props.name}>
                                    <Graphic
                                        colorScheme={this.props.options.colorScheme}
                                        type={this.props.options.type}
                                        data={this.props.rollupValue.data}
                                        fieldValueId={this.props.rollupValue.fieldValueId}
                                        fieldLabelId={this.props.rollupValue.fieldLabelId}
                                        part={this.props.options.type === chartType.bar.code ? this.props.options.bar : this.props.options.pie}
                                    />
                                </Container>
                                :
                                <Empty>{this.props.intl.formatMessage({id: "main.not_available"})}</Empty>
                            }
                        </React.Fragment>
                    }
                </React.Fragment>
            </React.Fragment>
        )
    }
}

export default injectIntl(GraphicCard)
